// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pc-birthday .feature-slide-text div .pulse a[data-v-2b178706]{background:#00a3da;color:#fff}.luck-birthday .feature-slide-text div .pulse a[data-v-2b178706]{background:#8a0ffe;color:#fff;font-weight:700}", ""]);
// Exports
module.exports = exports;
